import {toast} from "react-toastify";

class ToastManager {
  constructor() {
    this.activeToasts = new Set(); // Хранит активные сообщения
    this.activeErrorsStatuses = new Set();
  }

  showError(message, options = {}, errorStatus) {
    if (!this.activeToasts.has(message)) {
      if (errorStatus === 401 && this.activeErrorsStatuses.has(errorStatus)) {
        return;
      }
      this.activeToasts.add(message);
      this.activeErrorsStatuses.add(errorStatus);
      toast.error(message, {
        ...options,
        onClose: () => {
          this.activeToasts.delete(message); // Убираем сообщение из активных при закрытии
          this.activeErrorsStatuses.delete(errorStatus);
        },
      });
    }
  }

  // Можно добавить и другие методы для удобства
  showSuccess(message, options = {}) {
    toast.success(message, options);
  }

  clearAll() {
    toast.dismiss(); // Закрывает все уведомления
    this.activeToasts.clear();
  }
}

const toastInstance = new ToastManager();

export default toastInstance;
